import { INI } from '../../models/WbidINI';

export class AddINI {
  static readonly type = '[INI] add';
  constructor(public payload: INI) {}
}

export class RemoveINI {
  static readonly type = '[INI] remove';
  constructor() {
    /**/
  }
}
